module.exports = __webpack_public_path__ + "static/lageplan_offentlicheverkehrsmittel_mini-510db4f8f75ddf2a4d595bebdf5d04b6.png";